var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccounting({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 29,
    viewBox: "0 0 24 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_23_1926)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.3718 28.125H3.62819C2.08964 28.125 0.837585 26.7139 0.837585 24.9796V3.27051C0.837585 1.53615 2.08964 0.125031 3.62819 0.125031H20.3718C21.9104 0.125031 23.1624 1.53615 23.1624 3.27051V24.9796C23.1624 26.7139 21.9104 28.125 20.3718 28.125ZM3.62819 1.98543C3.12402 1.98543 2.69799 2.57379 2.69799 3.27051V24.9796C2.69799 25.6763 3.12402 26.2646 3.62819 26.2646H20.3718C20.876 26.2646 21.302 25.6763 21.302 24.9796V3.27051C21.302 2.57379 20.876 1.98543 20.3718 1.98543H3.62819Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.9997 9.17154H5.99968C4.89502 9.17154 4.9994 8.50003 4.9994 6.50003C4.9994 5.67153 4.89502 5.00003 5.99968 5.00003H17.9997C19.1044 5.00003 18.9994 5.67153 18.9994 6.50003C18.9994 8.50003 19.1044 9.17154 17.9997 9.17154Z",
    fill: "var(--menu-icon-accent, #8fb4ff)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.34939 13.2325H5.48898C4.87273 13.2325 4.37274 12.7325 4.37274 12.1163C4.37274 11.5 4.87273 11 5.48898 11H7.34939C7.96565 11 8.46563 11.5 8.46563 12.1163C8.46563 12.7325 7.96565 13.2325 7.34939 13.2325Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.9304 13.2325H11.07C10.4538 13.2325 9.9538 12.7325 9.9538 12.1163C9.9538 11.5 10.4538 11 11.07 11H12.9304C13.5467 11 14.0467 11.5 14.0467 12.1163C14.0467 12.7325 13.5467 13.2325 12.9304 13.2325Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M18.5115 13.2325H16.6511C16.0348 13.2325 15.5349 12.7325 15.5349 12.1163C15.5349 11.5 16.0348 11 16.6511 11H18.5115C19.1278 11 19.6277 11.5 19.6277 12.1163C19.6277 12.7325 19.1278 13.2325 18.5115 13.2325Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M12.9304 18.2325H11.07C10.4538 18.2325 9.9538 17.7325 9.9538 17.1163C9.9538 16.5 10.4538 16 11.07 16H12.9304C13.5467 16 14.0467 16.5 14.0467 17.1163C14.0467 17.7325 13.5467 18.2325 12.9304 18.2325Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M18.5115 18.2325H16.6511C16.0348 18.2325 15.5349 17.7325 15.5349 17.1163C15.5349 16.5 16.0348 16 16.6511 16H18.5115C19.1278 16 19.6277 16.5 19.6277 17.1163C19.6277 17.7325 19.1278 18.2325 18.5115 18.2325Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M18.5117 23.2325H11.07C10.4538 23.2325 9.9538 22.7325 9.9538 22.1163C9.9538 21.5 10.4538 21 11.07 21H18.5117C19.1279 21 19.6279 21.5 19.6279 22.1163C19.6279 22.7325 19.1279 23.2325 18.5117 23.2325Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M7.34939 18.2325H5.48898C4.87273 18.2325 4.37274 17.7325 4.37274 17.1163C4.37274 16.5 4.87273 16 5.48898 16H7.34939C7.96565 16 8.46563 16.5 8.46563 17.1163C8.46563 17.7325 7.96565 18.2325 7.34939 18.2325Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M7.34939 23.2325H5.48898C4.87273 23.2325 4.37274 22.7325 4.37274 22.1163C4.37274 21.5 4.87273 21 5.48898 21H7.34939C7.96565 21 8.46563 21.5 8.46563 22.1163C8.46563 22.7325 7.96565 23.2325 7.34939 23.2325Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_1926"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.3248,
    height: 28,
    fill: "white",
    transform: "translate(0.837585 0.125031)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccounting);
export default __webpack_public_path__ + "static/media/Accounting.ffc5a3f03582b0a4fd2f99a2b0fd6566.svg";
export { ForwardRef as ReactComponent };